import { ref } from "vue";
import { defineStore } from "pinia";
import {
  startTokenRefresh,
  stopTokenRefresh,
} from "@/composables/useTokenRefresh";
import { useRouter } from "vue-router";
import api from "@/services/api";

export const useUserStore = defineStore("user", () => {
  const router = useRouter();

  const id = ref();
  const name = ref("");
  const username = ref("");
  const notifyCount = ref(4);
  const isLogin = ref(false);
  const isLoading = ref(false);

  const login = async (user, password) => {
    isLoading.value = true;
    try {
      const data = await api.login(user, password);

      // 儲存 user 資料到 store
      id.value = data.id || data.userId;
      name.value = data.name || data.username || user;
      username.value = data.email || user;
      isLogin.value = true;

      // 進行登入 儲存資料
      localStorage.setItem("accessToken", data.accessToken || data.access_token);
      localStorage.setItem("refreshToken", data.refreshToken || data.refresh_token);
      // 客戶 2026-09-09：access token 15 分鐘過期，需定期主動 refresh
      startTokenRefresh();

      router.push("/");
    } catch (error) {
      console.log(error);
    } finally {
      setTimeout(() => {
        isLoading.value = false;
      }, 100);
    }
  };

  const logout = () => {
    stopTokenRefresh();
    localStorage.clear();
    location.href = "/login";
  };

  return { id, name, username, notifyCount, isLogin, login, logout, isLoading };
});
